import React, { useEffect, useState } from 'react';
import { SPECIAL_ENGLISH_AFFILIATE } from '../util/constants';
import { login, getCurrentUser, cleancookies, get2FAStatus, validate2FA } from '../util/AuthUtils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import LoginRegisterLayout from '../components/layout/login-register-layout';
import useLocalStorage from '../hooks/useLocalStorage'
import useStore from "../hooks/useStore";
import myDATALogo from '../img/mydata.png';
import '../styles/login.css';
import Commons from '../util/commons';

function LoginForm(props) {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [twoFactorStep, setTwoFactorStep] = useState(false);
    const [twoFactorCode, setTwoFactorCode] = useState("");
    const setBootstrapped = useStore((state) => state.setBootstrapped);
    const setLoggedInUser = useStore((state) => state.setLoggedInUser);
    const setSelectedCompany = useStore((state) => state.setSelectedCompany);
    const [, saveUser] = useLocalStorage("user", null);
    const [company, saveCompany, removeCompany] = useLocalStorage("company", null);

    const handleInputChange = (event) => {
        const target = event.target;
        const inputName = target.name;
        const inputValue = target.value;

        switch (inputName) {
            case "email": {
                setEmail(inputValue);
                break;
            }
            case "password": {
                setPassword(inputValue);
                break;
            }
            case "twoFactorCode": {
                setTwoFactorCode(inputValue);
                break;
            }
        }
    }

    const getCurrentUserCallback = (user) => {
        if (user.user.cleanCookies) {
            cleancookies().then(resp => {
                removeCompany();
                localStorage.removeItem("defaults")
                saveUser(user.user);
                if (user.companies && user.companies.length == 1) {
                    saveCompany(user.companies[0]);
                    setSelectedCompany(user.companies[0]);
                }
                setLoggedInUser(user.user)
                navigate("/home");
                props.setBlockuiLoading(false)
            }).catch(error => {
                console.error(error);
                saveUser(user);
                navigate("/home");
            });
        }
        else {
            saveUser(user.user);
            setLoggedInUser(user.user)
            if (user.companies && user.companies.length == 1) {
                saveCompany(user.companies[0]);
                setSelectedCompany(user.companies[0]);
            }
            else if (company) {
                const ids = user.companies.map(item => item.id);
                if (ids.includes(company.id)) {
                    const _company = user.companies.find(comp => comp.id === company.id);
                    saveCompany(_company);
                    setSelectedCompany(_company);
                }
                else {
                    removeCompany();
                    Commons.setDefault("branch", undefined);
                    Commons.setDefault("invoiceType", undefined);
                    Commons.setDefault("series", undefined);
                }
            }
            navigate("/home");
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        setError("");

        const loginRequest = {
            email: email,
            password: password
        }

        props.setBlockuiLoading(true)

        const loginCallback = () => {
            setBootstrapped(true);
            get2FAStatus()
                .then(statusResp => {
                    if (statusResp.enabled) {
                        props.setBlockuiLoading(false);
                        setTwoFactorStep(true);
                    } else {
                        getCurrentUser()
                            .then(getCurrentUserCallback)
                            .catch(err => { console.error(err); setLoading(false); });
                    }
                })
                .catch(() => {
                    getCurrentUser()
                        .then(getCurrentUserCallback)
                        .catch(err => { console.error(err); setLoading(false); });
                });
        }

        login(loginRequest)
            .then(loginCallback).catch(error => {
                console.error(error);
                props.setBlockuiLoading(false);
                if (error.response?.status === 401) {
                    setError(t("Invalid credentials"));
                } else {
                    setError(error.response?.data?.message || t("Login failed"));
                }
            });
    }

    const handleTwoFactorSubmit = (event) => {
        event.preventDefault();
        setError("");
        props.setBlockuiLoading(true);

        validate2FA(twoFactorCode)
            .then(() => {
                getCurrentUser()
                    .then(getCurrentUserCallback)
                    .catch(err => { console.error(err); props.setBlockuiLoading(false); });
            })
            .catch(err => {
                console.error(err);
                props.setBlockuiLoading(false);
                setError(t("Invalid 2FA code"));
            });
    }

    if (twoFactorStep) {
        return (
            <form onSubmit={handleTwoFactorSubmit}>
                {error && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {error}
                        <button type="button" className="btn-close" onClick={() => setError("")}></button>
                    </div>
                )}
                <p className="text-muted text-center">{t("Enter the 6-digit code from your authenticator app")}</p>
                <div className="login-form-item">
                    <input type="text" name="twoFactorCode"
                        className="form-control text-center"
                        placeholder="000000"
                        value={twoFactorCode}
                        onChange={handleInputChange}
                        maxLength={6}
                        autoFocus
                        required />
                </div>
                <hr />
                <div className="form-item">
                    <button type="submit" className="btn btn-block btn-skin">{t("Verify")}</button>
                </div>
                <div className="form-item text-center" style={{ marginTop: 8 }}>
                    <button type="button" className="btn btn-link btn-sm"
                        onClick={() => { setTwoFactorStep(false); setTwoFactorCode(""); setError(""); }}>
                        ← {t("Back")}
                    </button>
                </div>
            </form>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            {error && (
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    {error}
                    <button type="button" className="btn-close" onClick={() => setError("")}></button>
                </div>
            )}
            <div className="login-form-item">
                <input type="email" name="email"
                    className="form-control" placeholder="Email"
                    value={email} onChange={handleInputChange} required />
            </div>

            <div className="login-form-item">
                <input type="password" name="password"
                    className="form-control" placeholder={t("Password")}
                    value={password} onChange={handleInputChange} required />
            </div>
            <hr></hr>
            <div className="form-item">
                <button type="submit" className="btn btn-block btn-skin">{t("Connect")}</button>
            </div>
        </form>
    );
}

export default function Login(props) {
    const { t, i18n } = useTranslation();
    const [blockuiLoading, setBlockuiLoading] = useState(false);

    useEffect(() => {
        let params = (new URL(window.location)).searchParams;
        let aff = params.get('aff');
        if (aff == SPECIAL_ENGLISH_AFFILIATE) {
            i18n.changeLanguage("gb")
        }
        // If the OAuth2 login encounters an error, the user is redirected to the /login page with an error.
        // Here we display the error and then remove the error query parameter from the location.
        // if (window.location.state && window.location.state.error) {
        //     setTimeout(() => {
        //         console.error(window.location.state.error)
        //         alert(window.location.state.error);
        //         props.history.replace({
        //             pathname: window.location.pathname,
        //             state: {}
        //         });
        //     }, 100);
        // }
    }, []);

    const getRegisterUrl = () => {
        var url = "/register";

        let params = (new URL(window.location)).searchParams;
        let aff = params.get('aff');
        if (aff) {
            url += "?aff=" + aff;
        }
        return url;
    }

    if (props.authenticated) {
        return;

        // <Redirect
        //     to={{
        //         pathname: "/home",
        //         state: { from: window.location }
        //     }} />;
    }
    else {
        return (
            // <BlockUi loader={<Loader active type='square-spin' />} tag="div" blocking={blockuiLoading}>
            <LoginRegisterLayout>
                <LoginForm {...props} setBlockuiLoading={setBlockuiLoading} />
                <span className="signup-link">{t("newUserQuestionMess")} {t("makeRegisterMess")} <b>{t("FREE")}</b> {t("byClickingLink")} <Link to={getRegisterUrl()}>{t("here")}!</Link></span>
            </LoginRegisterLayout>
            // </BlockUi>
        );
    }

}
